import { useContext, useEffect, useState } from "react";
import useLocalStorage from "../../Utility/useLocalStorage";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import CardHome from "../../Components/CardHome";

const cards = [
  {
    id: 1,
    titolo: "ISEE",
    descrizione:
      "Potrai visualizzare gli ISEE caricati dai cittadini, verificarne il valore, confermarli o rifiutarli",
    badge: 0,
    link: "/lista_ISEE",
  },
  {
    id: 2,
    titolo: "UTENTI",
    descrizione:
      "Potrai visualizzare tutti gli utenti presenti nella  piattaforma, inserirne nuovi e caricare per loro l'Isee",
    badge: 0,
    link: "/lista_utenti",
  },
 
];

function HomeDelegate(props) {
  const [ISEEList, setISEEList] = useState();
  const [cardsState, setCardsState] = useState([]);
  const apiToken = useContext(TokenContext);
  const [loadedUser, setLoadedUser] = useState();
  //
  //setCardsState(cards);

  useEffect(() => {
    Repo.getIseeListUploaded(apiToken)
      .then((response) => {
        setISEEList(response.data.length > 0 && response.data.length);
        //console.log("ISEEList: " + response.data.length);

        // setCardsState(cards);

        let el = cards.map((item) => {
          if (item.id === 1) {
            item.badge = response.data.length;
          }
          return;
          item;
        });

        // Set the previous list to the new list
        setCardsState(el);
      })
      .catch((error) => {
        console.log(error);
      });

      Repo.getUsersLoadedCount(apiToken)
      .then((response) => {
        setLoadedUser(parseInt(response.data));
   //     console.log("setLoadedUser: " + parseInt(response.data));

        // setCardsState(cards);

        if (parseInt(response.data) > 0) {
          let e2 = cards.map((item) => {
            if (item.id === 2) {
              (item.badge = parseInt(response.data)),
                (item.link = "/lista_utenti?loaded=true");
            }
            return;
            item;
          });

          setCardsState(e2);
        }

      //  console.log("setLoadedUser: " + loadedUser);
        // Set the previous list to the new list
      })
      .catch((error) => {
        console.log(error);
      });


  }, []);


  return (
    <>
     <h1>Pannello delegato</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Riepilogo delle principali funzioni di{" "}
          <strong>Semplicita Servizi alla Persona</strong>
        </p>
      </div>
  {/* <div className="row">{cards.map(CardHome)}</div>*/}
    </>
  );
}

export default HomeDelegate;
